import { Observable } from 'rxjs';
import { ApiService } from '../api.service';
import { CommentView, Document } from '../../data/data.generated';
import { ChangesetView, Column, Enum, IData, Table } from '../../data/engineering-data';

export class EngineeringData {
  constructor(private _api: ApiService) {}

  public GetEnums(): Observable<Enum[]> {
    return this._api.Get<Enum[]>('GetEngineeringEnums', { });
  }

  public GetEngineeringEnumTypes(): Observable<string[]> {
    return this._api.Get<string[]>('GetEngineeringEnumTypes', {});
  }

  public CreateEngineeringEnumType(type: string): Observable<void> {
    return this._api.Post('CreateEngineeringEnumType', { Type: type });
  }

  public UpdateEngineeringEnums(type: string, enums: Enum[]): Observable<void> {
    return this._api.Post('UpdateEngineeringEnums', {
      Type: type,
      ReplaceAll: true,
      Enums: JSON.stringify(enums),
    });
  }

  public GetTableList(): Observable<Table[]> {
    return this._api.Get<Table[]>('GetEngineeringTableList', {});
  }

  public CreateEngineeringTable(table: Table): Observable<Table> {
    return this._api.Post('CreateEngineeringTable', {
      Name: table.Name,
      Description: table.Description,
    });
  }

  public UpdateEngineeringTable(table: Table): Observable<Table> {
    return this._api.Post('UpdateEngineeringTable', {
      TableId: table.Id,
      Name: table.Name,
      Description: table.Description,
    });
  }

  public GetTableColumns(tableId: number): Observable<Column[]> {
    return this._api.Get<Column[]>('GetEngineeringTableColumns', { TableId: tableId });
  }

  public UpdateEngineeringTableColumns(tableId: number, columns: Column[]): Observable<void> {
    return this._api.Post('UpdateEngineeringTableColumns', {
      TableId: tableId,
      Columns: JSON.stringify(columns),
    });
  }

  public GetChangesets(tableId: number): Observable<ChangesetView[]> {
    return this._api.Get<ChangesetView[]>('GetEngineeringChangesets', { TableId: tableId });
  }

  public GetTableData(tableId: number, changesetId: number): Observable<IData[]> {
    return this._api.Get<IData[]>('GetEngineeringTableData', { TableId: tableId, ChangesetId: changesetId });
  }

  public UpdateEngineeringData(tableId: number, modifiedData: IData[], unmodifiedIds: number[]): Observable<void> {
    return this._api.Post('UpdateEngineeringData', { TableId: tableId, ModifiedData: JSON.stringify(modifiedData), UnmodifiedIds: JSON.stringify(unmodifiedIds) });
  }

  public GetEngineeringToolSaveNotes(commentType: string, foreignKey: number): Observable<CommentView[]> {
    return this._api.Get<CommentView[]>('GetEngineeringToolSaveNotes', { CommentType: commentType, ForeignKey: foreignKey });
  }

}
